module["exports"] = [
  "#{Address.state} #{creature}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/team/name.js
// module id = 1121
// module chunks = 1